<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-28 17:00:35
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-29 09:14:46
 * @Description: header
 -->
<template>
  <div class="header-wrapper" :class="{ 'is-party': isParty }">
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  name: 'HeaderWrapper',
  props: {
    title: {
      type: String,
      default: ''
    },
    isParty: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped>
.header-wrapper {
  height: 196px;
  background: url('https://files.jinr.com/jinr-index/img/about-us-banner.png');
  background-size: 100% 100%;
  .title {
    text-align: center;
    line-height: 200px;
    font-size: 30px;
    color: #ffffff;
  }
}
.is-party {
  background: url('https://files.jinr.com/jinr-index/img/about-us-party.png');
}
</style>
